import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import DimensionSelect from './DimensionSelect';
import DimensionFilter from './DimensionFilter';

var Dimension = function Dimension(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'standard' : _ref$variant,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? null : _ref$label,
      onChange = _ref.onChange,
      dimension = _ref.dimension,
      _ref$hideFilter = _ref.hideFilter,
      hideFilter = _ref$hideFilter === void 0 ? false : _ref$hideFilter,
      _ref$hasFunction = _ref.hasFunction,
      hasFunction = _ref$hasFunction === void 0 ? false : _ref$hasFunction,
      _ref$forceFunction = _ref.forceFunction,
      forceFunction = _ref$forceFunction === void 0 ? false : _ref$forceFunction;

  var handleDimensionChange = function handleDimensionChange(value) {
    var isMeasure = value.indexOf('(') != -1 && value.indexOf(')') != -1;

    var _dimension = dimension,
        source = _dimension.source,
        expression = _dimension.expression,
        rest = _objectWithoutProperties(_dimension, ["source", "expression"]);

    var newDimension = _objectSpread({}, rest);

    if (isMeasure) newDimension.expression = value;else newDimension.source = value;
    onChange(newDimension);
  };

  var handleFiltersChange = function handleFiltersChange(filters) {
    onChange(_objectSpread({}, dimension, {
      filters: filters
    }));
  };

  dimension = dimension || {};
  return React.createElement("div", null, label && React.createElement(Typography, {
    gutterBottom: variant !== 'standard'
  }, label), React.createElement(Grid, {
    item: true,
    container: true,
    alignItems: "center"
  }, React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(DimensionSelect, {
    variant: variant,
    label: label,
    onChange: handleDimensionChange,
    value: dimension.source || dimension.expression,
    hasFunction: hasFunction,
    forceFunction: forceFunction
  })), !hideFilter && hasFunction && React.createElement(Grid, {
    item: true
  }, React.createElement(DimensionFilter, {
    disabled: !dimension.expression,
    filters: dimension.filters || [],
    onChange: handleFiltersChange
  }))));
};

export default Dimension;